// extracted by mini-css-extract-plugin
export var closeButton = "CloseButton_closeButton__hB+f2";